import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../config/rbac/actions.ts";

// Single-page module today: account-settings is one summary page. The aliases,
// personas and tags entries nested under it in the navbar are their own modules
// with their own routes, not children of this one. It still uses the module/*
// layout shape so the route carries its own RBAC gate (FNP-1119).
export const AccountSettingsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.GetAccountSettings) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
        </Routes>
    );
};
